import React from "react";
import {FaGithubSquare, FaLinkedin, FaTwitterSquare} from "react-icons/fa"

const Footer = () => {

  return (
    <section className="text-center">
      <p>Copyright © 2022 | By Nebe.Samson</p>
      <div>
        <a href="https://github.com/ChiemezieSamson" target="_blank"
          rel="noreferrer" className="text-4xl m-2 no-underline text-black"><FaGithubSquare/></a>
       <a href="https://www.linkedin.com/in/chiemezie-samson-nebeolisa-32897310b/" target="_blank"
          rel="noreferrer" className="text-4xl m-2 no-underline text-cyan-700"> <FaLinkedin/></a>
      <a href="https://twitter.com/NebeolisaGreen" target="_blank"
          rel="noreferrer" className="text-4xl m-2 no-underline text-sky-400"><FaTwitterSquare /></a>
      </div>
    </section>
  )
}

export default Footer